/** Tax-rate helpers. The database stores basis points (825 = 8.25%). */

/**
 * "8.25" or 8.25 → 825. Returns null for invalid input or out-of-range.
 * Keeps half basis points (4.875% → 487.5) because real rates like New York
 * City's 8.875% are not whole basis points; callers round when persisting to
 * the integer tax_rate_bps column.
 */
export function percentToBps(input: string | number): number | null {
  const value = typeof input === 'number' ? input : Number.parseFloat(input.trim().replace('%', ''));
  if (!Number.isFinite(value) || value < 0 || value > 100) return null;
  return Math.round(value * 200) / 2;
}

/** 825 → "8.25"; 887.5 → "8.875" (trimmed trailing zeros: 800 → "8"). */
export function bpsToPercent(bps: number): string {
  if (!Number.isFinite(bps) || bps < 0) return '0';
  const percent = bps / 100;
  return Number.isInteger(percent) ? String(percent) : percent.toFixed(3).replace(/0+$/, '').replace(/\.$/, '');
}

/** 825 → "8.25%" */
export function bpsToPercentLabel(bps: number): string {
  return `${bpsToPercent(bps)}%`;
}
